import React, { useState, useEffect, useCallback } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import config from "../../../../aws-exports";
import {
  FormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Switch,
  Button,
  IconButton,
  Box,
  Tooltip,
  Autocomplete,
  Modal,
  Paper,
} from "@mui/material";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchFilter from "../../../Requirement/components/common/SearchFilter";
import DataTable from "../../../Requirement/components/common/ReusableTable";
import OfferForm from "./OfferForm";
import { useLoading } from "../../../../context/LoadingContext";
import {
  fetchData,
  postQuery,
  uploadVideoToS3,
  searchfetchQueries,
} from "../../../Requirement/services/RequirementServices";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RemoveIcon from "@mui/icons-material/Remove";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FRfqMatchingOffers from "./FRfqMatchingOffers";
import TradeRFQModal from "./TradeRfqModal";
import formConfig from "./formtabs/formConfig";
import { validateForm, isFieldVisible } from "./formtabs/formUtils";
import TabForm from "./formtabs/TabForm";

const BankInputModal = ({
  open,
  onClose,
  onSubmit,
  bankList,
  selectedBanks,
  setSelectedBanks,
}) => {
  const { setLoading } = useLoading();
  const [localErrors, setLocalErrors] = useState({});
  const handleBankChange = (bank) => {
    setSelectedBanks((prev) => {
      const newSelected = prev.some((b) => b.BankID === bank.BankID)
        ? prev.filter((b) => b.BankID !== bank.BankID)
        : [...prev, bank];
      setLocalErrors({}); // Clear errors on change
      return newSelected;
    });
  };
  const validateBankForm = () => {
    return selectedBanks.length === 0
      ? { selection: "At least one bank must be selected" }
      : {};
  };
  const handleBankSubmit = () => {
    const errors = validateBankForm();
    if (Object.keys(errors).length > 0) {
      setLocalErrors(errors);
      return;
    } else {
      setLoading(true);
      onSubmit(selectedBanks);
       onClose(); // Pass the banks array to onSubmit
    }
    
  };
  const handleClose = () => {
    if (selectedBanks.length > 0) {
      if (
        window.confirm(
          "Are you sure you want to cancel? Unsaved bank selections will be lost."
        )
      ) {
        onClose();
      }
    } else {
      onClose();
    }
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Banks</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Please select at least one bank *
        </Typography>
        {bankList.map((bank) => (
          <FormControlLabel
            key={bank.BankID}
            control={
              <Checkbox
                checked={selectedBanks.some((b) => b.BankID === bank.BankID)}
                onChange={() => handleBankChange(bank)}
                name={bank.BankID}
              />
            }
            label={`${bank.BankName} (${bank.Address})`}
            sx={{ display: "block", marginBottom: 1 }}
          />
        ))}
        {localErrors.selection && (
          <Typography color="error" variant="body2">
            {localErrors.selection}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <div onClick={handleClose} className="submit-btn-more">
          Cancel
        </div>
        <div onClick={handleBankSubmit} className="submit-btn-more">
          Submit
        </div>
      </DialogActions>
    </Dialog>
  );
};

// Main Component
const FinanceRfqsOffers = ({ onSubmit, formMode = "edit" }) => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [searchValues, setSearchValues] = useState({
    searchFfqNumber: "",
    searchInstrumentType: "",
    searchPriceRange: "",
  });

  //merge related change -- start--
  const [openTradeRFQModal, setOpenTradeRFQModal] = useState(false);
  const handleOpenTradeRFQModal = useCallback(() => {
    console.log(
      "handleOpenTradeRFQModal called, setting openTradeRFQModal to true"
    );
    setOpenTradeRFQModal(true);
  }, []);

  const handleCloseTradeRFQModal = useCallback(() => {
    setOpenTradeRFQModal(false);
  }, []);

  const [selectedTradeRFQ, setSelectedTradeRFQ] = useState(null);

  //merge related change -- start--

  const priceOptions = [
    { value: "", label: "Select Range" },
    { value: "0-1000", label: "0-1000" },
    { value: "1000-2000", label: "1000-2000" },
    { value: "2000-5000", label: "2000-5000" },
    { value: "Above-5000", label: "Above 5000" },
  ];

  const [rfqList, setRfqList] = useState([]);

  const [rowStart, setRowStart] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isInstrumentSelected, setIsInstrumentSelected] = useState(false);
  const [selectedRequirement, setSelectedRequirement] = useState(null);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [selectedFormMode, setFormMode] = useState(formMode);
  const [isOfferDetailVisible, setIsOfferDetailVisible] = useState(false);
  const [offerDetailData, setOfferDetailData] = useState([]);
  const [isOfferFormVisible, setIsOfferFormVisible] = useState(false); // New state for OfferForm
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [activeUser, setActiveUser] = useState("");
  const [buyerInfo, setBuyerInfo] = useState([]);
  const [countrymaster, setCountryMaster] = useState([]);
  const [incotermsMaster, setIncotermsMaster] = useState([]);
  const [packagingMaster, setPackagingMaster] = useState([]);
  const [paymentTermMaster, setPaymentTermMaster] = useState([]);
  const [formOriginPortList, setFormOriginPortList] = useState([]);
  const [formDeliveryPortList, setFormDeliveryPortList] = useState([]);
  
  const [allPortList, setAllPortList] = useState([]);

  const [submitted, setSubmitted] = useState(false);
  // Initialize currentDate
  const currentDate = dayjs().format("YYYY-MM-DD");
  const [formData, setFormData] = useState({
    Id: "",
    RfqId: "",
    instrument: "",
    applicantName: "",
    beneficiaryName: "",
    lcAmount: 0,
    lcCurrency: "USD",
    lcType: "",
    lcTenor: "",
    incoterm: "",
    countryOrigin: "",
    countryDestination: "",
    goodsDescription: "",
    requiredDocuments: {
      commercialInvoice: false,
      billOfLading: false,
      certificateOfAnalysis: false,
      packingList: false,
      certificateOfOrigin: false,
      insurancePolicy: false,
      inspectionCertificate: false,
      claimDocs: false,
      underlyingContract: false,
      guaranteeTextDraft: false,
    },
    advisingConfirmingBank: "",
    lcOpeningBankDetails: "",
    expiryDate: currentDate,
    expiryPlace: "",
    paymentTerms: "",
    tradeType: "",
    commodityDescription: "",
    hsCode: "",
    buyerNameCountry: "",
    sellerNameCountry: "",
    instrumentTerms: "",
    shipmentDetails: "",
    dateFormat: "yyyy-MM-dd",
    proformaInvoiceFile: null, // Changed from array to null
    tradeDocsFile: null, // Changed from array to null
    kycDocsFile: null, // Changed from array to null
    additionalDocuments: "",
    specialConditions: "",
    offerValidityDate: "",
    expectedShipmentDate: "",
    latestShipmentDate: "",
    presentationPeriod: "",
    otherTerms: "",
    shipmentDate: currentDate,
    tradeValue: "",
    advisingConfirmingBankRequired: false,
    confirmationRequired: false,
    partialShipmentAllowed: false,
    transshipmentAllowed: false,
    confirmationCharges: "",
    issuanceCharges: "",
    interestRateMargin: "",
    tenorOffered: "",
    responseDeadline: currentDate,
    preferredFinancingRateType: "",
    maximumAcceptableCharges: "",
    additionalComments: "",
    imageAttachment: null,
    GuaranteeType: "",
    GuaranteeAmount: 0,
    GuaranteeValidityDate: "",
    ClaimExpiryDate: "",
    ClaimProcessInstructions: "",
    CounterGuarantee: "",
    UnderlyingContractRef: "",
    TriggerConditions: "",
    ExpiryEvent: "",
    CollectionMethod: "",
    CollectingBank: "",
    AcceptanceTerms: "",
    PaymentDueDate: "",
    InsuranceCoveragePercent: 0,
    PremiumAmountTerms: "",
    PolicyPeriod: "",
    EscrowAgentOrBank: "",
    EscrowAmount: 0,
    ReleaseConditions: "",
    CreditLimit: "",
    LatePaymentPenalty: "",
    Status: "",
  });
  const [errors, setErrors] = useState({});
  const [activeTab, setActiveTab] = useState(1);
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });
  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [selectedBanks, setSelectedBanks] = useState([]);
  const [documentVaultUserFiles, setDocumentVaultUserFiles] = useState([]);
  const [documentCategoryMaster, setDocumentCategoryMaster] = useState([]);
  const [openProformaModal, setOpenProformaModal] = useState(false);
  const [proformaDocumentValut, setProformaDocumentValut] = useState(false);
  const [tempProformaFile, setTempProformaFile] = useState(null);
  const [selectedProformaVaultFile, setSelectedProformaVaultFile] =
    useState(null);
  const [openTradeModal, setOpenTradeModal] = useState(false);
  const [tradeDocumentValut, setTradeDocumentValut] = useState(false);
  const [tempTradeFile, setTempTradeFile] = useState(null);
  const [selectedTradeVaultFile, setSelectedTradeVaultFile] = useState(null);
  const [openKycModal, setOpenKycModal] = useState(false);
  const [kycDocumentValut, setKycDocumentValut] = useState(false);
  const [tempKycFile, setTempKycFile] = useState(null);
  const [selectedKycVaultFile, setSelectedKycVaultFile] = useState(null);
  const [allProductMaster, setAllProductMaster] = useState([]);

  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  const filePath = `public/media/amtpl/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

  const handleBankModalClose = () => {
    setBankModalOpen(false);
    setSelectedBanks([]);
    setIsFormVisible(true); // Keep the form visible for corrections
  };
  const [bankList, setBankList] = useState([]);

  // Handlers for Proforma Modal
  const handleOpenProformaModal = useCallback(() => {
    setTempProformaFile(null);
    setProformaDocumentValut(false);
    setSelectedProformaVaultFile(null);
    setOpenProformaModal(true);
  }, []);

  const handleCloseProformaModal = useCallback(() => {
    setOpenProformaModal(false);
    setProformaDocumentValut(false);
    setTempProformaFile(null);
    setSelectedProformaVaultFile(null);
  }, []);

  const handleConfirmProforma = useCallback(() => {
    if (tempProformaFile) {
      setFormData((prev) => ({
        ...prev,
        proformaInvoiceFile: tempProformaFile,
      }));
    }
    handleCloseProformaModal();
  }, [tempProformaFile]);

  const handleTempProformaFileChange = useCallback((event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        setModal({
          show: true,
          type: "error",
          title: "Invalid File",
          message: "Please upload a PDF file.",
          autoClose: false,
        });
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setModal({
          show: true,
          type: "error",
          title: "File Too Large",
          message: "File size must not exceed 2MB.",
          autoClose: false,
        });
        return;
      }
      setTempProformaFile(file);
    }
  }, []);

  const handleAddDocProforma = useCallback(() => {
    setProformaDocumentValut(true);
    setTempProformaFile(null);
  }, []);

  const handleBackToProformaUploadOptions = useCallback(() => {
    setProformaDocumentValut(false);
    setTempProformaFile(null);
  }, []);

  // Handlers for Trade Modal
  const handleOpenTradeModal = useCallback(() => {
    setTempTradeFile(null);
    setTradeDocumentValut(false);
    setSelectedTradeVaultFile(null);
    setOpenTradeModal(true);
  }, []);

  const handleCloseTradeModal = useCallback(() => {
    setOpenTradeModal(false);
    setTradeDocumentValut(false);
    setTempTradeFile(null);
    setSelectedTradeVaultFile(null);
  }, []);

  const handleConfirmTrade = useCallback(() => {
    if (tempTradeFile) {
      setFormData((prev) => ({ ...prev, tradeDocsFile: tempTradeFile }));
    }
    handleCloseTradeModal();
  }, [tempTradeFile]);

  const handleTempTradeFileChange = useCallback((event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        setModal({
          show: true,
          type: "error",
          title: "Invalid File",
          message: "Please upload a PDF file.",
          autoClose: false,
        });
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setModal({
          show: true,
          type: "error",
          title: "File Too Large",
          message: "File size must not exceed 2MB.",
          autoClose: false,
        });
        return;
      }
      setTempTradeFile(file);
    }
  }, []);

  const handleAddDocTrade = useCallback(() => {
    setTradeDocumentValut(true);
    setTempTradeFile(null);
  }, []);

  const handleBackToTradeUploadOptions = useCallback(() => {
    setTradeDocumentValut(false);
    setTempTradeFile(null);
  }, []);

  // Handlers for Kyc Modal
  const handleOpenKycModal = useCallback(() => {
    setTempKycFile(null);
    setKycDocumentValut(false);
    setSelectedKycVaultFile(null);
    setOpenKycModal(true);
  }, []);

  const handleCloseKycModal = useCallback(() => {
    setOpenKycModal(false);
    setKycDocumentValut(false);
    setTempKycFile(null);
    setSelectedKycVaultFile(null);
  }, []);

  const handleConfirmKyc = useCallback(() => {
    if (tempKycFile) {
      setFormData((prev) => ({ ...prev, kycDocsFile: tempKycFile }));
    }
    handleCloseKycModal();
  }, [tempKycFile]);

  const handleTempKycFileChange = useCallback((event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        setModal({
          show: true,
          type: "error",
          title: "Invalid File",
          message: "Please upload a PDF file.",
          autoClose: false,
        });
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setModal({
          show: true,
          type: "error",
          title: "File Too Large",
          message: "File size must not exceed 2MB.",
          autoClose: false,
        });
        return;
      }
      setTempKycFile(file);
    }
  }, []);

  const handleAddDocKyc = useCallback(() => {
    setKycDocumentValut(true);
    setTempKycFile(null);
  }, []);

  const handleBackToKycUploadOptions = useCallback(() => {
    setKycDocumentValut(false);
    setTempKycFile(null);
  }, []);

  const loadAllProducts = useCallback(async () => {
    setLoading(true);
    try {
      const [allProducts] = await Promise.all([
        searchfetchQueries({
          target: "listAllProducts",
          userOrder: "ProductID",
          rowStart: 0,
          pageSize: 1000,
        }),
      ]);
      setAllProductMaster(allProducts);
      
    } catch (error) {
      console.error("Error loading products: ", error);
      setAllProductMaster([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);


  const loadUserDocumentVault = useCallback(async () => {
    setLoading(true);
    try {
      const [allDocs] = await Promise.all([
        searchfetchQueries({
          target: "listUserDocument",
          userOrder: "DocumentId",
          rowStart: 0,
          pageSize: 1000,
          CreatedBy: activeUser,
        }),
      ]);
      setDocumentVaultUserFiles(allDocs);
    } catch (error) {
      console.error("Error loading user document vault files: ", error);
      setDocumentVaultUserFiles([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading, activeUser]);

  const loadBankList = useCallback(async () => {
    setLoading(true);
    try {
      const [allBanks] = await Promise.all([
        searchfetchQueries({
          target: "listBankMaster",
          userOrder: "BankName",
          rowStart: 0,
          pageSize: 1000,
        }),
      ]);
      console.log(allBanks);
      setBankList(allBanks);
    } catch (error) {
      console.error("Error loading bank list: ", error);
      setBankList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadFormPorts = useCallback(
    async (country, fieldValue) => {
      setLoading(true);
      try {
        const allPorts = allPortList.filter((p) => p.Subtype === country);
        console.log("allPortList@@@", allPortList);
        if (allPorts.length > 0) {
          console.log("allPorts", allPorts);
          if (fieldValue === "origin") {
            setFormOriginPortList(allPorts);
          }
          if (fieldValue === "delivery") {
            setFormDeliveryPortList(allPorts);
          }
        } else {
          if (fieldValue === "origin") {
            setFormOriginPortList([]);
          }
          if (fieldValue === "delivery") {
            setFormDeliveryPortList([]);
          }
        }
      } catch (error) {
        console.error("Error loading ports: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allPortList]
  );
  

  function groupByType(items) {
    return items.reduce((acc, cur) => {
      const type = cur.Type;
      if (!acc[type]) acc[type] = [];
      acc[type].push(cur);
      return acc;
    }, {});
  }

  const loadAllDropdowns = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 100000,
      });

      const items = response.items ?? [];

      const groups = groupByType(items);

      setCountryMaster(groups.Country ?? []);
      setPaymentTermMaster(groups.paymentTerms ?? []);
      setIncotermsMaster(groups.Incoterms ?? []);
      setPackagingMaster(groups.packaging ?? []);
      setAllPortList(groups.port ?? []);
      setDocumentCategoryMaster(groups.DocCategory ?? []);
    } catch (err) {
      console.error("Failed to load dropdown options:", err);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Could not load dropdown lists. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const handleAdd = () => {
    console.log("formmode", formMode);
    console.log("formData@@@", formData);
    setFormMode("edit");
    if (isFormVisible || isOfferFormVisible) {
      handleReset();
    }
    console.log("buyerInfo@@", buyerInfo);
    const newFormData = {
      ...formData,
      applicantName:
        buyerInfo[0]?.FirstName + " " + buyerInfo[0]?.LastName || "",
      beneficiaryName: "Agropreneurs Market Technology Pvt Ltd",

      buyerNameCountry:
        buyerInfo[0]?.FirstName +
          " " +
          buyerInfo[0]?.LastName +
          "/" +
          buyerInfo[0]?.Country || "",
      sellerNameCountry: "Agropreneurs Market Technology Pvt Ltd/India",
    };
    setFormData(newFormData);
    setIsFormVisible(!isFormVisible);
    setIsOfferFormVisible(false); // Ensure OfferForm is hidden
    setIsEditMode(false);
    setIsInstrumentSelected(false);
    setIsOfferDetailVisible(false);
    setSelectedRequirement(null);
    setSelectedRFQ(null);
  };
  const parseDocumentsString = (str) => {
    if (!str)
      return {
        commercialInvoice: false,
        billOfLading: false,
        certificateOfAnalysis: false,
        packingList: false,
        certificateOfOrigin: false,
        insurancePolicy: false,
        inspectionCertificate: false,
      };

    const labelMap = {
      "Commercial Invoice": "commercialInvoice",
      "Bill of Lading": "billOfLading",
      "Certificate of Analysis": "certificateOfAnalysis",
      "Packing List": "packingList",
      "Certificate of Origin": "certificateOfOrigin",
      "Insurance Policy": "insurancePolicy",
      "Inspection Certificate": "inspectionCertificate",
      "Underlying Contract": "underlyingContract",
      "Claim Docs": "claimDocs",
      "Guarantee Text Draft": "guaranteeTextDraft",
    };
    const items = str.split(", ");
    return Object.keys(labelMap).reduce((acc, label) => {
      const key = labelMap[label];
      acc[key] = items.includes(label);
      return acc;
    }, {});
  };

  const handleActionClick = async (event, row, mode) => {
    // if (!row || typeof row !== "object") {
    //   console.error("Invalid row data:", row);
    //   return;
    // }
    console.log("row@@", row);
    event.stopPropagation();
    setSelectedRequirement(row);
    setSelectedRFQ(row);
    setIsOfferFormVisible(false);
    setIsEditMode(true);
    setIsInstrumentSelected(true);
    setFormMode(mode);
    setIsFormVisible(true);
    setActiveTab(1);
    console.log("row status", row["Status"]);
    console.log("banklist", bankList);
    // Fetch bank info from FinanceRfqBanks via API
    try {
      const response = await fetchData({
        target: "listFinanceRfqBanks",
        userOrder: "FinanceRfqBankID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { FinanceRfqID: row["Id"] || "" }, // Fallback to empty string if Id is undefined
      });
      let frfqBanks = response.items || [];
      console.log("listFinanceRfqBanks:", frfqBanks);
      const filteredBanks = bankList.filter((bank) =>
        frfqBanks.some((frfqBank) => frfqBank.BankID === bank.BankID)
      );
      console.log("filteredBanks@@", filteredBanks);
      setSelectedBanks(filteredBanks);
    } catch (error) {
      console.error("Error loading bank info:", error);
      setSelectedBanks([]);
    }

    setFormData((prevFormData) => ({
      ...prevFormData, // Preserve existing structure
      Id: row["Id"] || "",
      RfqId: row["RfqId"] || "",
      instrument: row["Instrument"] || "",
      applicantName: row["ApplicantName"] || "",
      beneficiaryName: row["BeneficiaryName"] || "",
      lcAmount: row["LcAmount"] || 0,
      lcCurrency: row["Currency"] || "USD",
      lcType: row["TypeOfLc"] || "",
      lcTenor: row["TenorLc"] || "",
      incoterm: row["Incoterms"] || "",
      countryOrigin: row["OriginCountry"] || "",
      countryDestination: row["DestinationCountry"] || "",
      goodsDescription: row["GoodsDescription"] || "",
      requiredDocuments: {
        ...prevFormData.requiredDocuments, // Merge with existing
        ...parseDocumentsString(row["RequiredDocuments"]),
      },
      advisingConfirmingBank: row["ConfirmingBank"] || "",
      lcOpeningBankDetails: row["LcBankDetails"] || "",
      expiryDate: row["ExpiryDate"] || currentDate,
      expiryPlace: row["ExpiryPlace"] || "",
      paymentTerms: row["PaymentTerms"] || "",
      tradeType: row["TradeType"] || "",
      commodityDescription: row["ComodityDescription"] || "",
      hsCode: row["Hscode"] || "",
      buyerNameCountry: row["BuyerName"] || "",
      sellerNameCountry: row["SellerName"] || "",
      portLoading: row["LoadingPort"] || "",
      portDischarge: row["DischargePort"] || "",
      tradeIncoterms: row["TradeIncoterms"] || "",
      shipmentDate: row["ShipmentDate"] || currentDate,
      tradeValue: row["TradeValue"] || "",
      advisingConfirmingBankRequired: row["ConfirmingBankRequired"] === "Y",
      confirmationRequired: row["ConfirmationRequired"] === "Y",
      partialShipmentAllowed: row["PartialShipmentAllowed"] === "Y",
      transshipmentAllowed: row["TransshipmentAllowed"] === "Y",
      instrumentTerms: row["InstrumentTerms"] || row["Instrument"] || "",
      confirmationCharges: row["ConfirmationCharges"] || "",
      issuanceCharges: row["IssuanceCharges"] || "",
      interestRateMargin: row["InterestRateMargin"] || "",
      tenorOffered: row["TenorOffered"] || "",
      additionalDocuments: row["AdditionalDocuments"] || "",
      specialConditions: row["SpecialClause"] || "",
      responseDeadline: row["ResponseDeadlineBank"] || currentDate,
      preferredFinancingRateType: row["PreferedFinanceRateType"] || "",
      maximumAcceptableCharges: row["MaxAcceptableCharges"] || "",
      additionalComments: row["AdditionalComments"] || "",
      proformaInvoiceFile: row["ProformaInvoiceFile"]
        ? {
            name: row["ProformaInvoiceFile"].split("/").pop(),
            filePath: row["ProformaInvoiceFile"],
          }
        : null,
      tradeDocsFile: row["TradeDocumentFile"]
        ? {
            name: row["TradeDocumentFile"].split("/").pop(),
            filePath: row["TradeDocumentFile"],
          }
        : null,
      kycDocsFile: row["KycDocumentFile"]
        ? {
            name: row["KycDocumentFile"].split("/").pop(),
            filePath: row["KycDocumentFile"],
          }
        : null,
      GuaranteeType: row["GuaranteeType"],
      GuaranteeAmount: row["GuaranteeAmount"],
      GuaranteeValidityDate: row["GuaranteeValidityDate"],
      ClaimExpiryDate: row["ClaimExpiryDate"],
      ClaimProcessInstructions: row["ClaimProcessInstructions"],
      CounterGuarantee: row["CounterGuarantee"],
      UnderlyingContractRef: row["UnderlyingContractRef"],
      TriggerConditions: row["TriggerConditions"],
      ExpiryEvent: row["ExpiryEvent"],
      CollectionMethod: row["CollectionMethod"],
      CollectingBank: row["CollectingBank"],
      AcceptanceTerms: row["AcceptanceTerms"],
      PaymentDueDate: row["PaymentDueDate"],
      InsuranceCoveragePercent: row["InsuranceCoveragePercent"],
      PremiumAmountTerms: row["PremiumAmountTerms"],
      PolicyPeriod: row["PolicyPeriod"],
      EscrowAgentOrBank: row["EscrowAgentOrBank"],
      EscrowAmount: row["EscrowAmount"],
      ReleaseConditions: row["ReleaseConditions"],
      CreditLimit: row["CreditLimit"],
      LatePaymentPenalty: row["LatePaymentPenalty"],
      Status: row["Status"],
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prevFormData) => {
      let newFormData = { ...prevFormData };
      if (type === "checkbox") {
        if (Object.keys(prevFormData.requiredDocuments || {}).includes(name)) {
          newFormData = {
            ...prevFormData,
            requiredDocuments: {
              ...prevFormData.requiredDocuments,
              [name]: checked,
            },
          };
        } else {
          newFormData = {
            ...prevFormData,
            [name]: checked,
          };
        }
      } else if (type === "file" && name === "imageAttachment") {
        newFormData = {
          ...prevFormData,
          [name]: files[0],
        };
      } else {
        const newValue =
          name === "lcAmount" ||
          name === "tradeValue" ||
          name === "confirmationCharges" ||
          name === "issuanceCharges" ||
          name === "interestRateMargin"
            ? parseFloat(value) || 0
            : value;
        newFormData = {
          ...prevFormData,
          [name]: newValue,
        };
        if (name === "instrument" && value) {
          setIsInstrumentSelected(true);
          newFormData.instrumentTerms = value;
        }
      }
      return newFormData;
    });
  };

  const getDocumentsString = (data) => {
    const labelMap = {
      commercialInvoice: "Commercial Invoice",
      billOfLading: "Bill of Lading",
      certificateOfAnalysis: "Certificate of Analysis",
      packingList: "Packing List",
      certificateOfOrigin: "Certificate of Origin",
      insurancePolicy: "Insurance Policy",
      inspectionCertificate: "Inspection Certificate",
      underlyingContract: "Underlying Contract",
      claimDocs: "Claim Docs",
      guaranteeTextDraft: "Guarantee Text Draft",
    };
    return Object.entries(data)
      .filter(([_, value]) => value) // only keep true values
      .map(([key]) => labelMap[key]) // map key to readable label
      .join(", "); // comma separated
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitted(true);
    // Validate form only on submit
    const validationErrors = validateForm(formData, formData.instrument);
    if (Object.keys(validationErrors).length > 0) {
      console.log("open modal");
      setModal({
        show: true,
        type: "error",
        title: "Validation Error",
        message:
          "Please fill in all required fields: " +
          Object.values(validationErrors).join(", "),
        autoClose: false,
      });
      setErrors(validationErrors);
      setLoading(false);
      setSubmitted(false);
      return;
    }
    if (!isEditMode) {
      setBankModalOpen(true);
      setLoading(false);
      setSubmitted(false);
      return;
    }
    await submitRfq(selectedBanks);
  };
  const submitRfq = async (selectedBanks) => {
    console.log("selectedBanks@@@", selectedBanks);
    console.log("formData@@@", formData);
    // return;
    try {
      let editModeSelectedBanks = [];
      if (formData.Status === "Draft") {
        editModeSelectedBanks = selectedBanks;
      }
      const curreDate = new Date();
      const defaultShipmentDate = dayjs(curreDate).format("YYYY-MM-DD");
      const reqNoDate = dayjs(curreDate).format("YYYYMMDD");
      let Id = formData.Id || uuidv4();
      let RfqId = formData.RfqId;
      if (!isEditMode) {
        const reqCount = totalItems + 1;
        RfqId = reqNoDate + reqCount;
      }
      let Title = formData.instrument || "Demo Title Hard Code";
      let Instrument = formData.instrument || "";
      let ApplicantName = formData.applicantName || "";
      let BeneficiaryName = formData.beneficiaryName || "";
      let LcAmount = parseFloat(formData.lcAmount) || 0;
      let Currency = formData.lcCurrency || "USD";
      let TypeOfLc = formData.lcType || "";
      let Incoterms = formData.incoterm || "";
      let OriginCountry = formData.countryOrigin || "";
      let DestinationCountry = formData.countryDestination || "";
      let GoodsDescription = formData.goodsDescription || "";
      const requiredDocumentsStr = getDocumentsString(
        formData.requiredDocuments
      );
      let ConfirmingBank = formData.advisingConfirmingBank || "";
      let LcBankDetails = formData.lcOpeningBankDetails || "";
      let ExpiryDate = formData.expiryDate
        ? dayjs(formData.expiryDate).format("YYYY-MM-DD")
        : null;
      let ExpiryPlace = formData.expiryPlace || "";
      let PaymentTerms = formData.paymentTerms || "";
      let TradeType = formData.tradeType || "";
      let ComodityDescription = formData.commodityDescription || "";
      let Hscode = formData.hsCode || "";
      let BuyerName = formData.buyerNameCountry || "";
      let BuyerCountry = formData.buyerNameCountry || "";
      let SellerName = formData.sellerNameCountry || "";
      let SellerCountry = formData.sellerNameCountry || "";
      let LoadingPort = formData.portLoading || " ";
      let DischargePort = formData.portDischarge || " ";
      let TradeIncoterms = formData.tradeIncoterms || "";
      let ShipmentDate = formData.shipmentDate
        ? dayjs(formData.shipmentDate).format("YYYY-MM-DD")
        : defaultShipmentDate;
      let TradeValue = parseFloat(formData.tradeValue) || 0;
      let ConfirmingBankRequired = formData.advisingConfirmingBankRequired
        ? "Y"
        : "N";
      let ConfirmationRequired = formData.confirmationRequired ? "Y" : "N";
      let PartialShipmentAllowed = formData.partialShipmentAllowed ? "Y" : "N";
      let TransshipmentAllowed = formData.transshipmentAllowed ? "Y" : "N";
      let InstrumentTerms =
        formData.instrumentTerms || formData.instrument || "";
      let ConfirmationCharges = parseFloat(formData.confirmationCharges) || 0;
      let IssuanceCharges = parseFloat(formData.issuanceCharges) || 0;
      let InterestRateMargin = parseFloat(formData.interestRateMargin) || 0;
      let TenorOffered = formData.tenorOffered || "";
      let AdditionalDocuments = formData.additionalDocuments || "";
      let SpecialClause = formData.specialConditions || "";
      let ResponseDeadlineBank = formData.responseDeadline
        ? dayjs(formData.responseDeadline).format("YYYY-MM-DD")
        : null;
      let PreferedFinanceRateType = formData.preferredFinancingRateType || "";
      let MaxAcceptableCharges = formData.maximumAcceptableCharges || "";
      let AdditionalComments = formData.additionalComments || "";
      const selectedBanksData = isEditMode
        ? editModeSelectedBanks
        : selectedBanks;
      // Upload single file to S3 and get filename
      let proformaInvoiceFileRef = "";
      let tradeDocsFileRef = "";
      let kycDocsFileRef = "";
      let proformaInvoiceFileRefUrl = "";
      let tradeDocsFileRefUrl = "";
      let kycDocsFileRefUrl = "";

      let GuaranteeType = formData.GuaranteeType || " ";
      let GuaranteeAmount = parseFloat(formData.GuaranteeAmount) || 0;
      let GuaranteeValidityDate = formData.GuaranteeValidityDate
        ? dayjs(formData.GuaranteeValidityDate).format("YYYY-MM-DD")
        : defaultShipmentDate;
      let ClaimExpiryDate = formData.ClaimExpiryDate
        ? dayjs(formData.ClaimExpiryDate).format("YYYY-MM-DD")
        : defaultShipmentDate;
      let ClaimProcessInstructions = formData.ClaimProcessInstructions || " ";
      let CounterGuarantee = formData.CounterGuarantee || " ";
      let UnderlyingContractRef = formData.UnderlyingContractRef || " ";
      let TriggerConditions = formData.TriggerConditions || " ";
      let ExpiryEvent = formData.ExpiryEvent || " ";
      let CollectionMethod = formData.CollectionMethod || " ";
      let CollectingBank = formData.CollectingBank || " ";
      let AcceptanceTerms = formData.AcceptanceTerms || " ";
      let PaymentDueDate = formData.PaymentDueDate
        ? dayjs(formData.PaymentDueDate).format("YYYY-MM-DD")
        : defaultShipmentDate;
      let InsuranceCoveragePercent =
        parseFloat(formData.InsuranceCoveragePercent) || 0;
      let PremiumAmountTerms = formData.PremiumAmountTerms || " ";
      let PolicyPeriod = formData.PolicyPeriod || " ";
      let EscrowAgentOrBank = formData.EscrowAgentOrBank || " ";
      let EscrowAmount = parseFloat(formData.EscrowAmount) || 0;
      let ReleaseConditions = formData.ReleaseConditions || " ";
      let CreditLimit = formData.CreditLimit || " ";
      let LatePaymentPenalty = formData.LatePaymentPenalty || " ";

      try {
        const file = formData.proformaInvoiceFile;
        if (file instanceof File) {
          console.log("Uploading proformaInvoiceFile:", file);
          const result = await uploadVideoToS3(file);
          proformaInvoiceFileRef = result.fileName;
          proformaInvoiceFileRefUrl = result.url;
        } else if (file?.filePath) {
          proformaInvoiceFileRef = file.filePath;
          proformaInvoiceFileRefUrl = file.filePath; // Assume url is same or adjust if needed
        } else if (file?.DocumentFile) {
          proformaInvoiceFileRef = file.DocumentFile;
          proformaInvoiceFileRefUrl = file.DocumentFile;
        }

        const tradeFile = formData.tradeDocsFile;
        if (tradeFile instanceof File) {
          console.log("Uploading tradeDocsFile:", tradeFile);
          const result = await uploadVideoToS3(tradeFile);
          tradeDocsFileRef = result.fileName;
          tradeDocsFileRefUrl = result.url;
        } else if (tradeFile?.filePath) {
          tradeDocsFileRef = tradeFile.filePath;
          tradeDocsFileRefUrl = tradeFile.filePath;
        } else if (tradeFile?.DocumentFile) {
          tradeDocsFileRef = tradeFile.DocumentFile;
          tradeDocsFileRefUrl = tradeFile.DocumentFile;
        }

        const kycFile = formData.kycDocsFile;
        if (kycFile instanceof File) {
          console.log("Uploading kycDocsFile:", kycFile);
          const result = await uploadVideoToS3(kycFile);
          kycDocsFileRef = result.fileName;
          kycDocsFileRefUrl = result.url;
        } else if (kycFile?.filePath) {
          kycDocsFileRef = kycFile.filePath;
          kycDocsFileRefUrl = kycFile.filePath;
        } else if (kycFile?.DocumentFile) {
          kycDocsFileRef = kycFile.DocumentFile;
          kycDocsFileRefUrl = kycFile.DocumentFile;
        }
      } catch (uploadError) {
        console.error("File upload error:", uploadError);
        throw new Error("Failed to upload one or more files to S3.");
      }
      const financeRfqInput = {
        Id: Id,
        RfqId: RfqId,
        Title: Title,
        Instrument: Instrument,
        ApplicantName: ApplicantName,
        BeneficiaryName: BeneficiaryName,
        LcAmount: LcAmount,
        Currency: Currency,
        TypeOfLc: TypeOfLc,
        Incoterms: Incoterms,
        OriginCountry: OriginCountry,
        DestinationCountry: DestinationCountry,
        GoodsDescription: GoodsDescription,
        RequiredDocuments: requiredDocumentsStr,
        ConfirmingBank: ConfirmingBank,
        LcBankDetails: LcBankDetails,
        ExpiryDate: ExpiryDate,
        ExpiryPlace: ExpiryPlace,
        PaymentTerms: PaymentTerms,
        TradeType: TradeType,
        ComodityDescription: ComodityDescription,
        Hscode: Hscode,
        BuyerName: BuyerName,
        BuyerCountry: BuyerCountry,
        SellerName: SellerName,
        SellerCountry: SellerCountry,
        LoadingPort: LoadingPort,
        DischargePort: DischargePort,
        TradeIncoterms: TradeIncoterms,
        ShipmentDate: ShipmentDate,
        TradeValue: TradeValue,
        ConfirmingBankRequired: ConfirmingBankRequired,
        ConfirmationRequired: ConfirmationRequired,
        PartialShipmentAllowed: PartialShipmentAllowed,
        TransshipmentAllowed: TransshipmentAllowed,
        InstrumentTerms: InstrumentTerms,
        ConfirmationCharges: ConfirmationCharges,
        IssuanceCharges: IssuanceCharges,
        InterestRateMargin: InterestRateMargin,
        TenorOffered: TenorOffered,
        AdditionalDocuments: AdditionalDocuments,
        SpecialClause: SpecialClause,
        ProformaInvoiceFile: proformaInvoiceFileRef || "",
        TradeDocumentFile: tradeDocsFileRef || "",
        KycDocumentFile: kycDocsFileRef || "",
        ResponseDeadlineBank: ResponseDeadlineBank,
        PreferedFinanceRateType: PreferedFinanceRateType,
        MaxAcceptableCharges: MaxAcceptableCharges,
        AdditionalComments: AdditionalComments,
        CreatedBy: activeUser,
        GuaranteeType: GuaranteeType,
        GuaranteeAmount: GuaranteeAmount,
        GuaranteeValidityDate: GuaranteeValidityDate,
        ClaimExpiryDate: ClaimExpiryDate,
        ClaimProcessInstructions: ClaimProcessInstructions,
        CounterGuarantee: CounterGuarantee,
        UnderlyingContractRef: UnderlyingContractRef,
        TriggerConditions: TriggerConditions,
        ExpiryEvent: ExpiryEvent,
        CollectionMethod: CollectionMethod,
        CollectingBank: CollectingBank,
        AcceptanceTerms: AcceptanceTerms,
        PaymentDueDate: PaymentDueDate,
        InsuranceCoveragePercent: InsuranceCoveragePercent,
        PremiumAmountTerms: PremiumAmountTerms,
        PolicyPeriod: PolicyPeriod,
        EscrowAgentOrBank: EscrowAgentOrBank,
        EscrowAmount: EscrowAmount,
        ReleaseConditions: ReleaseConditions,
        CreditLimit: CreditLimit,
        LatePaymentPenalty: LatePaymentPenalty,
        Status: "Submitted",
      };
      const body = {
        target: isEditMode ? "updateFinanceRfq" : "createFinanceRfq",
        financeRfqInput,
      };
      const result = await postQuery(body);
      if (!result || !result.items)
        throw new Error(`Failed to ${isEditMode ? "update" : "create"} RFQ.`);

      if (!isEditMode && selectedBanksData.length > 0) {
        const bankPromises = selectedBanksData.map(async (bank) => {
          const financeRfqBanksInput = {
            FinanceRfqBankID: uuidv4(),
            FinanceRfqID: result.items.Id || Id, // Use Id from response or fallback to generated Id
            BankID: bank.BankID,
          };
          const bankBody = {
            target: "createFinanceRfqBanks",
            financeRfqBanksInput,
          };
          await postQuery(bankBody);
        });

        // Execute all bank API calls in parallel
        await Promise.all(bankPromises).catch((error) => {
          console.error("Error creating FinanceRfqBanks:", error);
          throw new Error("Failed to associate banks with RFQ.");
        });
      }

      const utf8ToBase64 = (str) => {
        try {
          const utf8Bytes = new TextEncoder().encode(str);
          const binary = Array.from(utf8Bytes)
            .map((byte) => String.fromCharCode(byte))
            .join("");
          return btoa(binary);
        } catch (error) {
          console.error("Base64 encoding error:", error);
          console.error("Input string:", str);
          throw new Error("Failed to encode query string for email link.");
        }
      };
      console.log("selectedBanksData@@", selectedBanksData);
      // Send individual emails to each selected bank
      const emailPromises = selectedBanksData.map(async (bank) => {
        const selectedBanksString = `${bank.BankName} (${bank.Address}, ${bank.Email})`;
        console.log("submit-bank@@", bank);
        console.log("selectedBanksString@@", selectedBanksString);
        // Encode query parameters
        const sanitize = (str) => {
          console.log("Before sanitization:", str); // log original string
          const cleaned = str.replace(/[^\x00-\xFF]/g, "");
          console.log("After sanitization:", cleaned); // log cleaned string
          return cleaned;
        };

        const queryString = `id=${encodeURIComponent(
          sanitize(Id)
        )}&RfqId=${encodeURIComponent(
          sanitize(RfqId)
        )}&bankName=${encodeURIComponent(
          sanitize(bank.BankName)
        )}&bankId=${encodeURIComponent(bank.BankID)}&user=${encodeURIComponent(
          sanitize(activeUser)
        )}&instrument=${encodeURIComponent(sanitize(Instrument))}`;
        console.log("Query string before encoding:", queryString); // Debug log
        const encrypted = utf8ToBase64(queryString);
        const encodedEncrypted = encodeURIComponent(encrypted);
        const baseURL = window.location.origin;
        const mailMessage = `<p>A ${
          isEditMode ? "updated" : "new"
        } payment & financing instrument <b>${Instrument}</b> has been submitted. Please find all the submitted information below for your reference.</p>
        <strong><u>RFQ Overview</u></strong>
        <p>
            <b>RFQ ID: </b>${RfqId}<br/>
            <b>Applicant Name (Buyer): </b>${ApplicantName}<br/>
            <b>Beneficiary Name (Seller): </b>${BeneficiaryName}<br/>
            <b>LC Amount : </b>${LcAmount}<br/>
            <b>Currency : </b>${Currency}<br/>
            <b>Type of LC: </b>${TypeOfLc}<br/>
            <b>Incoterm: </b>${Incoterms}<br/>
            <b>Country of Origin: </b>${OriginCountry}<br/>
            <b>Country of Destination: </b>${DestinationCountry}<br/>
            <b>Goods Description: </b><p>${GoodsDescription}<p>
            <b>Required Documents: </b>${requiredDocumentsStr}<br/>
            <b>Advising / Confirming Bank: </b>${ConfirmingBank}<br/>
            <b>LC Opening Bank Details: </b>${LcBankDetails}<br/>
            <b>Selected Bank: </b>${selectedBanksString}<br/>
            <b>Expiry Date: </b>${
              ExpiryDate ? dayjs(ExpiryDate).format("DD-MM-YYYY") : ""
            }<br/>
            <b>Payment Terms: </b>${PaymentTerms}<br/>
        </p><strong><u>Trade & Transaction Details</u></strong>
        <p>
            <b>Trade Type: </b>${TradeType}<br/>
            <b>Commodity Description: </b>${ComodityDescription}<br/>
            <b>HS Code: </b>${Hscode}<br/>
            <b>Buyer Name & Country: </b>${BuyerName} <br/>
            <b>Seller Name & Country: </b>${SellerName}<br/>
            <b>Port of Loading: </b>${LoadingPort}<br/>
            <b>Port of Discharge: </b>${DischargePort}<br/>
            <b>Shipment Date (Estimated): </b>${
              ShipmentDate ? dayjs(ShipmentDate).format("DD-MM-YYYY") : ""
            }<br/>
            <b>Trade Value (Invoice Amount): </b>${TradeValue}<br/>
        </p><strong><u>Instrument Terms</u></strong>
        <p>
            <b>Advising / Confirming Bank Required? </b>${
              ConfirmingBankRequired === "Y" ? "Yes" : "No"
            }<br/>
            <b>Confirmation Required? </b>${
              ConfirmationRequired === "Y" ? "Yes" : "No"
            }<br/>
            <b>Partial Shipment Allowed? </b>${
              PartialShipmentAllowed === "Y" ? "Yes" : "No"
            }<br/>
            <b>Transshipment Allowed? </b>${
              TransshipmentAllowed === "Y" ? "Yes" : "No"
            }<br/>
            <b>Instrument Terms: </b>${InstrumentTerms}<br/>
            <b>Confirmation Charges: </b>${ConfirmationCharges}<br/>
            <b>Issuance Charges: </b>${IssuanceCharges}<br/>
            <b>Interest Rate Margin (%): </b>${InterestRateMargin}<br/>
            <b>Tenor Offered (Days/Months): </b>${TenorOffered}<br/>
            <b>Guarantee Type: </b>${GuaranteeType}<br/>
            <b>Guarantee Amount: </b>${GuaranteeAmount}<br/>
            <b>Guarantee Validity Date: </b>${GuaranteeValidityDate}<br/>
            <b>Claim Expiry Date: </b>${ClaimExpiryDate}<br/>
            <b>Claim Process Instructions: </b>${ClaimProcessInstructions}<br/>
            <b>Counter Guarantee: </b>${CounterGuarantee}<br/>
            <b>Underlying Contract Ref: </b>${UnderlyingContractRef}<br/>
            <b>Trigger Conditions: </b>${TriggerConditions}<br/>
            <b>Expiry Event: </b>${ExpiryEvent}<br/>
            <b>Collection Method: </b>${CollectionMethod}<br/>
            <b>Collecting Bank: </b>${CollectingBank}<br/>
            <b>Acceptance Terms: </b>${AcceptanceTerms}<br/>
            <b>Payment Due Date: </b>${PaymentDueDate}<br/>
            <b>Insurance Coverage Percent: </b>${InsuranceCoveragePercent}<br/>
            <b>Premium Amount Terms: </b>${PremiumAmountTerms}<br/>
            <b>Policy Period: </b>${PolicyPeriod}<br/>
            <b>Escrow Agent/Bank: </b>${EscrowAgentOrBank}<br/>
            <b>Escrow Amount: </b>${EscrowAmount}<br/>
            <b>Release Conditions: </b>${ReleaseConditions}<br/>
            <b>Credit Limit: </b>${CreditLimit}<br/>
            <b>Late Payment Penalty: </b>${LatePaymentPenalty}<br/>
        </p><strong><u>Document Requirements</u></strong>
        <p>
            <b>Documents Required: </b>${requiredDocumentsStr}<br/>
            <b>Additional Documents: </b>${AdditionalDocuments}<br/>
            <b>Special Conditions / Clauses: </b>${SpecialClause}<br/>
        </p><strong><u>Attachments</u></strong>
        <p>
            <b>Proforma Invoice / Contract: </b><a href="${
              fileUrl + proformaInvoiceFileRef
            }">${proformaInvoiceFileRef || ""}</a><br/>
            <b>Supporting Trade Docs (PO, BL, KYB, etc.): </b><a href="${
              fileUrl + tradeDocsFileRef
            }">${tradeDocsFileRef || ""}</a><br/>
            <b>Company Profile / KYC Docs: </b><a href="${
              fileUrl + kycDocsFileRef
            }">${kycDocsFileRef || ""}</a><br/>
        </p><strong><u>Terms & Timing</u></strong>
        <p>
            <b>Response Deadline for Banks: </b>${
              ResponseDeadlineBank
                ? dayjs(ResponseDeadlineBank).format("DD-MM-YYYY")
                : ""
            }<br/>
            <b>Preferred Financing Rate Type: </b>${PreferedFinanceRateType}<br/>
            <b>Maximum Acceptable Charges (% or absolute): </b>${MaxAcceptableCharges}<br/>
            <b>Additional Comments / Clarifications: </b>${AdditionalComments}<br/>
        </p>
        <p>
        Click on the button to fill-up your bank information.
        </p><table border="0" cellpadding="0" cellspacing="0" style="margin: 10px 0;">
          <tr>
            <td style="background-color: #de6b14; padding: 10px 20px; text-align: center; border-radius: 5px;">
              <a href="${baseURL}/bank-info?p=${encodedEncrypted}" style="color: #ffffff; text-decoration: none; font-family: Arial, sans-serif; font-size: 16px; font-weight: bold; display: inline-block;">Click Here</a>
            </td>
          </tr>
        </table>`;
        const bodyMail = {
          target: "financerfqmail",
          MailInput: {
            toAddresses: [bank.Email],
            subject: `Finance RFQ Notification`,
            msg: mailMessage,
          },
        };
        return postQuery(bodyMail, "backendops");
      });
      // Send emails in parallel
      await Promise.all(emailPromises);
      setModal({
        show: true,
        type: "success",
        title: "Success!",
        message: `Finance RFQ ${RfqId} ${
          isEditMode ? "updated" : "created"
        } successfully.`,
        autoClose: false,
        nextAction: () => {
          navigate("/buyer/finance/rfqoffers");
          setIsFormVisible(false);
          setIsOfferFormVisible(false);
          setIsOfferDetailVisible(false);
          searchRFQs(searchValues);
        },
      });
    } catch (error) {
      console.error("Submission error:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message:
          error.message ||
          `Failed to ${isEditMode ? "update" : "submit"} Finance RFQ.`,
        autoClose: false,
      });
    } finally {
      setLoading(false);
      setSubmitted(false);
      setBankModalOpen(false);
      setSelectedBanks([]);
      handleReset();
    }
  };
  const handleReset = () => {
    setFormData({
      Id: "",
      RfqId: "",
      instrument: "",
      applicantName: "",
      beneficiaryName: "",
      lcAmount: 0,
      lcCurrency: "USD",
      lcType: "",
      lcTenor: "",
      incoterm: "",
      countryOrigin: "",
      countryDestination: "",
      goodsDescription: "",
      requiredDocuments: {
        commercialInvoice: false,
        billOfLading: false,
        certificateOfAnalysis: false,
        packingList: false,
        certificateOfOrigin: false,
        insurancePolicy: false,
        inspectionCertificate: false,
        claimDocs: false,
        underlyingContract: false,
        guaranteeTextDraft: false,
      },
      advisingConfirmingBank: "",
      lcOpeningBankDetails: "",
      expiryDate: currentDate,
      expiryPlace: "",
      paymentTerms: "",
      tradeType: "",
      commodityDescription: "",
      hsCode: "",
      buyerNameCountry: "",
      sellerNameCountry: "",
      instrumentTerms: "",
      shipmentDetails: "",
      dateFormat: "yyyy-MM-dd",
      proformaInvoiceFile: null,
      tradeDocsFile: null,
      kycDocsFile: null,
      additionalDocuments: "",
      specialConditions: "",
      offerValidityDate: "",
      expectedShipmentDate: "",
      latestShipmentDate: "",
      presentationPeriod: "",
      otherTerms: "",
      shipmentDate: currentDate,
      tradeValue: "",
      advisingConfirmingBankRequired: false,
      confirmationRequired: false,
      partialShipmentAllowed: false,
      transshipmentAllowed: false,
      confirmationCharges: "",
      issuanceCharges: "",
      interestRateMargin: "",
      tenorOffered: "",
      responseDeadline: currentDate,
      preferredFinancingRateType: "",
      maximumAcceptableCharges: "",
      additionalComments: "",
      imageAttachment: null,
      GuaranteeType: "",
      GuaranteeAmount: 0,
      GuaranteeValidityDate: "",
      ClaimExpiryDate: "",
      ClaimProcessInstructions: "",
      CounterGuarantee: "",
      UnderlyingContractRef: "",
      TriggerConditions: "",
      ExpiryEvent: "",
      CollectionMethod: "",
      CollectingBank: "",
      AcceptanceTerms: "",
      PaymentDueDate: "",
      InsuranceCoveragePercent: 0,
      PremiumAmountTerms: "",
      PolicyPeriod: "",
      EscrowAgentOrBank: "",
      EscrowAmount: 0,
      ReleaseConditions: "",
      CreditLimit: "",
      LatePaymentPenalty: "",
      Status: "",
    });
    setErrors({});
    setIsInstrumentSelected(false);
  };
  const fields = [
    {
      name: "searchRfqNumber",
      label: "RFQ No.",
      type: "text",
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, searchRfqNumber: value })),
      value: searchValues.searchRfqNumber,
    },
    {
      name: "searchInstrumentType",
      label: "Instrument",
      type: "dropdown",
      options: [
        "Letter of Credit (LC) - Sight / Usance / Back-to-Back",
        "Deferred Payment Terms with LC",
        "Bank Guarantee (BG) - Payment / Performance",
        "Standby Letter of Credit (SBLC)",
        "Buyer's Credit / Trade Loan",
        "Documentary Collection (D/P or D/A)",
        "Open Account with Credit Insurance",
      ],
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, searchInstrumentType: value })),
      value: searchValues.searchInstrumentType,
    },
    {
      name: "searchPriceRange",
      label: "Price Range",
      type: "dropdown",
      options: priceOptions,
      value: searchValues.searchPriceRange,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchPriceRange: value }));
        searchRFQs({ ...searchValues, searchPriceRange: value }, 0);
      },
    },
  ];

  const columns = [
    { id: "RfqId", numeric: false, label: "RFQ ID" },
    { id: "Title", numeric: false, label: "Title" },
    { id: "Instrument", numeric: false, label: "Instrument" },
    { id: "ApplicantName", numeric: false, label: "Applicant Name" },
    { id: "TypeOfLc", numeric: false, label: "Type Of LC" },
    { id: "TradeValue", numeric: false, label: "Trade Value" },
    { id: "LcAmount", numeric: false, label: "LC Amount" },
    {
      id: "Status",
      numeric: false,
      label: "Status",
      renderCell: (row) => {
        let bgColor = "",
          textColor = "";
        switch (row.Status) {
          case "Draft":
            bgColor = "#fef3c7";
            textColor = "#b45309";
            break;
          case "Submitted":
            bgColor = "#ceded1ff";
            textColor = "#129e25ff";
            break;
          default:
            bgColor = "#f3f4f6";
            textColor = "#374151";
        }
        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "3px 6px",
              borderRadius: "25px",
              fontSize: "0.75rem",
              fontWeight: 500,
              width: "120px",
            }}
          >
            {row.Status}
          </span>
        );
      },
    },
    {
      id: "action",
      numeric: false,
      label: "Action",
      renderCell: (row) => (
        <div
          className="edit-icon"
          style={{
            display: "flex",
            gap: "2px",
            alignItems: "center",
            margin: 0,
            padding: 0,
          }}
        >
          <Tooltip title="Edit Requirement">
            <IconButton
              onClick={(e) => handleActionClick(e, row, "edit")}
              sx={{ color: "#de6b14" }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleSearch = () => {
    setRowStart(0);
  };
  const handleOffersSearch = () => {
    setRowStart(0);
  };
  const handlePageChange = useCallback(
    (page) => {
      const newRowStart = (page - 1) * pageSize;
      setRowStart(newRowStart);
      setIsOfferDetailVisible(false);
    },
    [pageSize]
  );
  // const currentDate = new Date().toISOString().split("T")[0];
  const currentPage = Math.floor(rowStart / pageSize) + 1;
  const getBuyerInfo = useCallback(async (buyerEmail) => {
    try {
      const response = await fetchData({
        target: "listAMTPLUsers",
        userOrder: "AMTPLUserID",
        rowStart: 0,
        pageSize: 100,
        filterTerms: { EmailID: buyerEmail },
      });
      setBuyerInfo(response.items || []);
    } catch (error) {
      console.error("Error loading buyer info:", error);
      setBuyerInfo([]);
    }
  }, []);
  const searchRFQs = useCallback(
    async (searchValue, newRowStart = rowStart) => {
      setLoading(true);
      try {
        let priceFilter = {};
        if (searchValue.searchPriceRange) {
          if (searchValue.searchPriceRange === "Above-5000") {
            priceFilter = { TradeValueGTE: 5000 };
          } else {
            const searchPrice = searchValue.searchPriceRange;
            const [min, max] = searchPrice
              .split("-")
              .map((val) => parseFloat(val));
            priceFilter = {
              TradeValueGTE: min,
              TradeValueLTE: max,
            };
          }
        }
        const body = {
          target: "listFinanceRfq",
          userOrder: "RfqId DESC",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            CreatedBy: activeUser,
            Instrument: searchValue.searchInstrumentType || "",
            RfqId: searchValue.searchRfqNumber || "",
            ...priceFilter,
          },
        };
        const response = await fetchData(body);
        const modifiedItems = (response.items || response).map((item) => ({
          ...item,
          id: item.Id,
        }));
        setRfqList(modifiedItems);
        setTotalItems(response.total || 0);
      } catch (error) {
        console.error("Error loading RFQs: ", error);
        setRfqList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [pageSize, rowStart, setLoading, activeUser]
  );
  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_BUYERS")) {
          await Auth.signOut();
          navigate("/login/buyer");
        } else {
          setActiveUser(user.attributes.email);
          getBuyerInfo(user.attributes.email);
        }
      } catch (error) {
        console.error("Error checking user:", error);
        await Auth.signOut();
        navigate("/login/buyer");
      }
    };
    checkUser();
    loadAllDropdowns();
    loadAllProducts();
    if (activeUser) {
      loadUserDocumentVault();
    }
    loadBankList();

  }, [
    navigate,
    activeUser,
    getBuyerInfo,
    loadAllDropdowns,
    loadBankList,
    loadUserDocumentVault,
    loadAllProducts,
  ]);
  useEffect(() => {
    if (activeUser) {
      searchRFQs(searchValues);
    }
  }, [rowStart, pageSize, activeUser, searchRFQs, searchValues]);
  // Automatically load ports when countryOrigin or countryDestination changes
  useEffect(() => {
    if (formData.countryOrigin) {
      console.log("Country of Origin changed:", formData.countryOrigin);
      loadFormPorts(formData.countryOrigin, "origin");
      console.log("origin port", formOriginPortList);
    } else {
      setFormOriginPortList([]);
      setFormData((prev) => ({
        ...prev,
        portLoading: "",
        errors: { ...prev.errors, portLoading: "" },
      }));
    }
  }, [formData.countryOrigin, loadFormPorts]);

  useEffect(() => {
    if (formData.countryDestination) {
      console.log(
        "Country of Destination changed:",
        formData.countryDestination
      );
      loadFormPorts(formData.countryDestination, "delivery");
    } else {
      setFormDeliveryPortList([]);
      setFormData((prev) => ({
        ...prev,
        portDischarge: "",
        errors: { ...prev.errors, portDischarge: "" },
      }));
    }
  }, [formData.countryDestination, loadFormPorts]);

  // Update formData when selectedTradeRfq changes
  useEffect(() => {
    if (selectedTradeRFQ) {
      const location = selectedTradeRFQ.DeliveryLocation;
      let destination = "";
      let deliveryPort = "";
      if (location) {
        const [dest, port] = location.split("~");
        destination = dest || "";
        deliveryPort = port || "";
      }
      const selTradeRfqProductID = selectedTradeRFQ.ProductID || "";
      let product = "";
      if (selTradeRfqProductID) {
        product = allProductMaster.find(
          (p) => p.ProductID === selTradeRfqProductID
        );
      }
      let LcAmountDerived = 0;
      LcAmountDerived =
        parseFloat(selectedTradeRFQ.Price) *
        parseFloat(selectedTradeRFQ.Quantity);

      const newFormData = {
        ...formData,
        applicantName:
          buyerInfo[0]?.FirstName + " " + buyerInfo[0]?.LastName || "",
        beneficiaryName: "Agropreneurs Market Technology Pvt Ltd",
        lcAmount: LcAmountDerived || 0,
        lcCurrency: "USD",
        lcType: "Sight",
        paymentTerms: selectedTradeRFQ.PreferredPaymentMethod,
        lcTenor: selectedTradeRFQ.PaymentTimeline || "",
        incoterm: selectedTradeRFQ.Incoterm || "",
        countryOrigin: selectedTradeRFQ.OriginCountry || "",
        countryDestination: destination || "",
        goodsDescription: selectedTradeRFQ.ProductSpecifications || "",
        expiryDate: selectedTradeRFQ.ValidUntil?.split(" ")[0] || currentDate,
        tradeType: "Import",
        commodityDescription: product
          ? product.ProductName + "/" + product.Grade
          : "",
        hsCode: selectedTradeRFQ.HsCode || "",
        buyerNameCountry:
          buyerInfo[0]?.FirstName +
            " " +
            buyerInfo[0]?.LastName +
            "/" +
            buyerInfo[0]?.Country || "",
        sellerNameCountry: "Agropreneurs Market Technology Pvt Ltd/India",
        portDischarge: deliveryPort || "",
        shipmentDate:
          selectedTradeRFQ.DeliveryPeriodFrom?.split(" ")[0] || currentDate,
        tradeValue: LcAmountDerived || "",
        partialShipmentAllowed: true,
        transshipmentAllowed: selectedTradeRFQ.TransshipmentAllowed || true,
        tenorOffered: selectedTradeRFQ.PaymentTimeline || "",
        specialConditions: selectedTradeRFQ.SpecialInstructionsSuppliers || "",
        additionalComments: selectedTradeRFQ.UnloadingResponsibility || "",
        GuaranteeType: "",
        GuaranteeAmount: 0,
        GuaranteeValidityDate: "",
        ClaimExpiryDate: "",
        ClaimProcessInstructions: "",
        CounterGuarantee: "",
        UnderlyingContractRef: "",
        TriggerConditions: "",
        ExpiryEvent: "",
        CollectionMethod: "",
        CollectingBank: "",
        AcceptanceTerms: "",
        PaymentDueDate: "",
        InsuranceCoveragePercent: 0,
        PremiumAmountTerms: "",
        PolicyPeriod: "",
        EscrowAgentOrBank: "",
        EscrowAmount: 0,
        ReleaseConditions: "",
        CreditLimit: "",
        LatePaymentPenalty: "",
        Status: "",
      };
      setFormData(newFormData);
    }
  }, [selectedTradeRFQ, buyerInfo, allProductMaster]);

  const handleChildResponse = () => {
    console.log("parent handleChildResponse");
    console.log("selectedTradeRFQ@@@@", selectedTradeRFQ);
  };

  const handleRowClick = (row, event) => {
    setSelectedRequirement(row);
    setIsOfferDetailVisible(true);
    setIsFormVisible(false);
    setIsOfferFormVisible(false);
    setSelectedRFQ(row);
    setFormMode("view");
    setIsFormVisible(true);
    setActiveTab(1);
    setIsInstrumentSelected(true);

    setFormData({
      ...formData,
      Id: row["Id"] || "",
      RfqId: row["RfqId"] || "",
      instrument: row["Instrument"] || "",
      applicantName: row["ApplicantName"] || "",
      beneficiaryName: row["BeneficiaryName"] || "",
      lcAmount: row["LcAmount"] || 0,
      lcCurrency: row["Currency"] || "USD",
      lcType: row["TypeOfLc"] || "",
      lcTenor: row["TenorLc"] || "",
      incoterm: row["Incoterms"] || "",
      countryOrigin: row["OriginCountry"] || "",
      countryDestination: row["DestinationCountry"] || "",
      goodsDescription: row["GoodsDescription"] || "",
      requiredDocuments: parseDocumentsString(row["RequiredDocuments"]),
      advisingConfirmingBank: row["ConfirmingBank"] || "",
      lcOpeningBankDetails: row["LcBankDetails"] || "",
      expiryDate: row["ExpiryDate"] || currentDate,
      expiryPlace: row["ExpiryPlace"] || "",
      paymentTerms: row["PaymentTerms"] || "",
      tradeType: row["TradeType"] || "",
      commodityDescription: row["ComodityDescription"] || "",
      hsCode: row["Hscode"] || "",
      buyerNameCountry: row["BuyerName"] || "",
      sellerNameCountry: row["SellerName"] || "",
      portLoading: row["LoadingPort"] || "",
      portDischarge: row["DischargePort"] || "",
      tradeIncoterms: row["TradeIncoterms"] || "",
      shipmentDate: row["ShipmentDate"] || currentDate,
      tradeValue: row["TradeValue"] || "",
      advisingConfirmingBankRequired: row["ConfirmingBankRequired"] === "Y",
      confirmationRequired: row["ConfirmationRequired"] === "Y",
      partialShipmentAllowed: row["PartialShipmentAllowed"] === "Y",
      transshipmentAllowed: row["TransshipmentAllowed"] === "Y",
      instrumentTerms: row["InstrumentTerms"] || row["Instrument"] || "",
      confirmationCharges: row["ConfirmationCharges"] || "",
      issuanceCharges: row["IssuanceCharges"] || "",
      interestRateMargin: row["InterestRateMargin"] || "",
      tenorOffered: row["TenorOffered"] || "",
      additionalDocuments: row["AdditionalDocuments"] || "",
      specialConditions: row["SpecialClause"] || "",
      responseDeadline: row["ResponseDeadlineBank"] || currentDate,
      preferredFinancingRateType: row["PreferedFinanceRateType"] || "",
      maximumAcceptableCharges: row["MaxAcceptableCharges"] || "",
      additionalComments: row["AdditionalComments"] || "",
      proformaInvoiceFile: row["ProformaInvoiceFile"]
        ? {
            name: row["ProformaInvoiceFile"].split("/").pop(),
            filePath: row["ProformaInvoiceFile"],
          }
        : null,
      tradeDocsFile: row["TradeDocumentFile"]
        ? {
            name: row["TradeDocumentFile"].split("/").pop(),
            filePath: row["TradeDocumentFile"],
          }
        : null,
      kycDocsFile: row["KycDocumentFile"]
        ? {
            name: row["KycDocumentFile"].split("/").pop(),
            filePath: row["KycDocumentFile"],
          }
        : null,
      GuaranteeType: row["GuaranteeType"],
      GuaranteeAmount: row["GuaranteeAmount"],
      GuaranteeValidityDate: row["GuaranteeValidityDate"],
      ClaimExpiryDate: row["ClaimExpiryDate"],
      ClaimProcessInstructions: row["ClaimProcessInstructions"],
      CounterGuarantee: row["CounterGuarantee"],
      UnderlyingContractRef: row["UnderlyingContractRef"],
      TriggerConditions: row["TriggerConditions"],
      ExpiryEvent: row["ExpiryEvent"],
      CollectionMethod: row["CollectionMethod"],
      CollectingBank: row["CollectingBank"],
      AcceptanceTerms: row["AcceptanceTerms"],
      PaymentDueDate: row["PaymentDueDate"],
      InsuranceCoveragePercent: row["InsuranceCoveragePercent"],
      PremiumAmountTerms: row["PremiumAmountTerms"],
      PolicyPeriod: row["PolicyPeriod"],
      EscrowAgentOrBank: row["EscrowAgentOrBank"],
      EscrowAmount: row["EscrowAmount"],
      ReleaseConditions: row["ReleaseConditions"],
      CreditLimit: row["CreditLimit"],
      LatePaymentPenalty: row["LatePaymentPenalty"],
      Status: row["Status"],
    });
  };

  // const selectedRows = selectedRequirement ? [selectedRequirement.Id] : [];
  const selectedRows = selectedRequirement
    ? [selectedRequirement.RequirementsID || selectedRequirement.Id]
    : [];

  console.log("####selectedRows####", selectedRows);

  return (
    <div className="container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <BankInputModal
        open={bankModalOpen}
        onClose={handleBankModalClose}
        onSubmit={submitRfq}
        bankList={bankList}
        selectedBanks={selectedBanks}
        setSelectedBanks={setSelectedBanks}
      />
      <TradeRFQModal
        open={openTradeRFQModal}
        onClose={handleCloseTradeRFQModal}
        buyerInfo={buyerInfo}
        activeUser={activeUser}
        selectedTradeRFQ={selectedTradeRFQ}
        setSelectedTradeRFQ={setSelectedTradeRFQ}
        onResponse={handleChildResponse}
      />

      <div className="rfq-container">
        <div className="table-header-re">
          <div className="head-btn">
            <button
              className="submit-btn"
              onClick={handleAdd}
              aria-label={isFormVisible ? "Cancel adding RFQ" : "Add new RFQ"}
            >
              {isFormVisible ? "Cancel" : "Add"}
            </button>
          </div>
        </div>
        <div className="search-filter4">
          <div className="title4">
            <div className="head-text">RFQ</div>
          </div>
          <div className="filter4">
            <SearchFilter fields={fields} onSearch={handleSearch} />
          </div>
        </div>
        <div className="table-content">
          <DataTable
            columns={columns}
            data={rfqList}
            total={totalItems}
            title="RFQs"
            rowsPerPage={pageSize}
            onPageChange={handlePageChange}
            currentPage={currentPage}
            selectedRows={selectedRows}
            onRowClick={handleRowClick}
          />
        </div>
        {isOfferDetailVisible && (
          <div>
            <FRfqMatchingOffers
              key={selectedRequirement?.Id || selectedRequirement?.RfqId} // Use a unique identifier
              selectedRfq={selectedRequirement}
              activeUser={activeUser}
              userInfo={buyerInfo}
              bankList={bankList}
            />
          </div>
        )}
        {isFormVisible && (
          // <TabForm
          //   activeTab={activeTab}
          //   setActiveTab={setActiveTab}
          //   fileUrl={fileUrl}
          //   formData={formData}
          //   setFormData={setFormData}
          //   errors={errors}
          //   handleChange={handleChange}
          //   handleSubmit={handleSubmit}
          //   handleReset={handleReset}
          //   handleAdd={handleAdd}
          //   isEditMode={isEditMode}
          //   isInstrumentSelected={isInstrumentSelected}
          //   formMode={selectedFormMode}
          //   currentDate={currentDate}
          //   countrymaster={countrymaster}
          //   incotermsMaster={incotermsMaster}
          //   paymentTermMaster={paymentTermMaster}
          //   loadFormPorts={loadFormPorts}
          //   formOriginPortList={formOriginPortList}
          //   formDeliveryPortList={formDeliveryPortList}
          //   handleOpenProformaModal={handleOpenProformaModal}
          //   handleOpenTradeModal={handleOpenTradeModal}
          //   handleOpenKycModal={handleOpenKycModal}
          //   openTradeRFQModal={openTradeRFQModal}
          //   handleCloseTradeRFQModal={handleCloseTradeRFQModal}
          //   handleOpenTradeRFQModal={handleOpenTradeRFQModal}
          //   buyerInfo={buyerInfo}
          //   activeUser={activeUser}
          //   selectedTradeRFQ={selectedTradeRFQ}
          // />
          <TabForm
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            fileUrl={fileUrl}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleReset={handleReset}
            handleAdd={handleAdd}
            isEditMode={isEditMode}
            isInstrumentSelected={isInstrumentSelected}
            formMode={selectedFormMode}
            currentDate={currentDate}
            countrymaster={countrymaster}
            incotermsMaster={incotermsMaster}
            paymentTermMaster={paymentTermMaster}
            loadFormPorts={loadFormPorts}
            formOriginPortList={formOriginPortList}
            formDeliveryPortList={formDeliveryPortList}
            handleOpenProformaModal={handleOpenProformaModal}
            handleOpenTradeModal={handleOpenTradeModal}
            handleOpenKycModal={handleOpenKycModal}
            openTradeRFQModal={openTradeRFQModal}
            handleCloseTradeRFQModal={handleCloseTradeRFQModal}
            handleOpenTradeRFQModal={handleOpenTradeRFQModal}
            buyerInfo={buyerInfo}
            activeUser={activeUser}
            selectedTradeRFQ={selectedTradeRFQ}
            setModal={setModal}
          />
        )}
        {isOfferFormVisible && selectedOffer && (
          <>
            <div className="tab-content-main">
              <div className="table-header" style={{ marginBottom: "16px" }}>
                <div className="title4">
                  <div className="head-text">Offer Details</div>
                </div>
                <div className="button-group">
                  <Button className="btn-action-re">Accept</Button>
                  <Button className="btn-action-re">Reject</Button>
                  <Button className="btn-action-re">Negotiate</Button>
                  <Button className="btn-action-re">Chat</Button>
                </div>
              </div>
              <OfferForm selectedOffer={selectedOffer} />
            </div>
          </>
        )}
      </div>
      {/* Proforma Modal */}
      <Modal open={openProformaModal} onClose={handleCloseProformaModal}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="h6">
              Upload Proforma Invoice / Contract
            </Typography>
            <IconButton onClick={handleCloseProformaModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          {/* Conditional rendering based on proformaDocumentValut */}
          {proformaDocumentValut ? (
            <>
              {/* Back Button */}
              <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleBackToProformaUploadOptions}
                  sx={{
                    border: "1px solid #FF5722",
                    color: "#FF5722",
                    textTransform: "capitalize",
                  }}
                >
                  Back
                </Button>
              </Box>
              {/* First Autocomplete for documentCategoryMaster */}
              <FormControl sx={{ width: "100%", mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                >
                  Search Document Category
                </Typography>
                <Autocomplete
                  options={documentCategoryMaster}
                  getOptionLabel={(option) => option.Value || ""}
                  onChange={(event, newValue) => {
                    setSelectedProformaVaultFile(newValue);
                    setTempProformaFile(null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Type to search categories..."
                      variant="outlined"
                      sx={{
                        height: "40px !important",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ff9800",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#fb8c00",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff3e0",
                        },
                      }}
                    >
                      <Typography variant="body2">{option.Value}</Typography>
                    </Box>
                  )}
                  noOptionsText="No categories found"
                  sx={{ backgroundColor: "white" }}
                />
              </FormControl>
              {/* Second Autocomplete for documentVaultUserFiles when a category is selected */}
              {selectedProformaVaultFile && (
                <FormControl sx={{ width: "100%", mb: 3 }}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                  >
                    Select Document
                  </Typography>
                  <Autocomplete
                    options={documentVaultUserFiles.filter(
                      (doc) => doc.Category === selectedProformaVaultFile.Value
                    )}
                    getOptionLabel={(option) => option.DocumentName || ""}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setTempProformaFile({
                          name: newValue.DocumentName,
                          DocumentFile: newValue.DocumentFile,
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Type to search documents..."
                        variant="outlined"
                        sx={{
                          height: "40px !important",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                            borderRadius: "4px",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#ff9800",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#fb8c00",
                            },
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          "&:hover": {
                            backgroundColor: "#fff3e0",
                          },
                        }}
                      >
                        <Typography variant="body2">
                          {option.DocumentName}
                        </Typography>
                      </Box>
                    )}
                    noOptionsText="No documents found"
                    sx={{ backgroundColor: "white" }}
                  />
                </FormControl>
              )}
              {/* Selected Files List */}
              <Box>
                {tempProformaFile ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "5px",
                      borderRadius: "8px",
                      bgcolor: "#f5f5f5",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2">
                      {tempProformaFile.name}
                    </Typography>
                    <IconButton
                      onClick={() => {
                        setTempProformaFile(null);
                      }}
                    >
                      <CloseIcon sx={{ color: "#555" }} />
                    </IconButton>
                  </Box>
                ) : (
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    No file selected
                  </Typography>
                )}
              </Box>
            </>
          ) : tempProformaFile ? (
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Typography variant="body2" sx={{ mr: 1 }}>
                {tempProformaFile.name}
              </Typography>
              <IconButton onClick={() => setTempProformaFile(null)}>
                <RemoveIcon
                  sx={{
                    backgroundColor: "#fb8c00",
                    color: "#fff",
                    borderRadius: "24px",
                    width: "35px",
                    height: "35px",
                  }}
                />
              </IconButton>
            </Box>
          ) : (
            <div className="doc-des">
              <Button
                variant="outlined"
                onClick={handleAddDocProforma}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload File from Document Vault
              </Button>
              <br />
              <Button
                variant="outlined"
                component="label"
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload file from Local Drive
                <input
                  type="file"
                  hidden
                  onChange={(e) => setTempProformaFile(e.target.files[0])}
                  accept="application/pdf"
                />
              </Button>
            </div>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleConfirmProforma}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
              disabled={!tempProformaFile}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Modal>
      {/*  Trade Modal */}
      <Modal open={openTradeModal} onClose={handleCloseTradeModal}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="h6">Upload Supporting Trade Docs</Typography>
            <IconButton onClick={handleCloseTradeModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          {/* Conditional rendering based on tradeDocumentValut */}
          {tradeDocumentValut ? (
            <>
              {/* Back Button */}
              <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleBackToTradeUploadOptions}
                  sx={{
                    border: "1px solid #FF5722",
                    color: "#FF5722",
                    textTransform: "capitalize",
                  }}
                >
                  Back
                </Button>
              </Box>
              {/* First Autocomplete for documentCategoryMaster */}
              <FormControl sx={{ width: "100%", mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                >
                  Search Document Category
                </Typography>
                <Autocomplete
                  options={documentCategoryMaster}
                  getOptionLabel={(option) => option.Value || ""}
                  onChange={(event, newValue) => {
                    setSelectedTradeVaultFile(newValue);
                    setTempTradeFile(null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Type to search categories..."
                      variant="outlined"
                      sx={{
                        height: "40px !important",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ff9800",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#fb8c00",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff3e0",
                        },
                      }}
                    >
                      <Typography variant="body2">{option.Value}</Typography>
                    </Box>
                  )}
                  noOptionsText="No categories found"
                  sx={{ backgroundColor: "white" }}
                />
              </FormControl>
              {/* Second Autocomplete for documentVaultUserFiles when a category is selected */}
              {selectedTradeVaultFile && (
                <FormControl sx={{ width: "100%", mb: 3 }}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                  >
                    Select Document
                  </Typography>
                  <Autocomplete
                    options={documentVaultUserFiles.filter(
                      (doc) => doc.Category === selectedTradeVaultFile.Value
                    )}
                    getOptionLabel={(option) => option.DocumentName || ""}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setTempTradeFile({
                          name: newValue.DocumentName,
                          DocumentFile: newValue.DocumentFile,
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Type to search documents..."
                        variant="outlined"
                        sx={{
                          height: "40px !important",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                            borderRadius: "4px",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#ff9800",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#fb8c00",
                            },
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          "&:hover": {
                            backgroundColor: "#fff3e0",
                          },
                        }}
                      >
                        <Typography variant="body2">
                          {option.DocumentName}
                        </Typography>
                      </Box>
                    )}
                    noOptionsText="No documents found"
                    sx={{ backgroundColor: "white" }}
                  />
                </FormControl>
              )}
              {/* Selected Files List */}
              <Box>
                {tempTradeFile ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "5px",
                      borderRadius: "8px",
                      bgcolor: "#f5f5f5",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2">
                      {tempTradeFile.name}
                    </Typography>
                    <IconButton
                      onClick={() => {
                        setTempTradeFile(null);
                      }}
                    >
                      <CloseIcon sx={{ color: "#555" }} />
                    </IconButton>
                  </Box>
                ) : (
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    No file selected
                  </Typography>
                )}
              </Box>
            </>
          ) : tempTradeFile ? (
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Typography variant="body2" sx={{ mr: 1 }}>
                {tempTradeFile.name}
              </Typography>
              <IconButton onClick={() => setTempTradeFile(null)}>
                <RemoveIcon
                  sx={{
                    backgroundColor: "#fb8c00",
                    color: "#fff",
                    borderRadius: "24px",
                    width: "35px",
                    height: "35px",
                  }}
                />
              </IconButton>
            </Box>
          ) : (
            <div className="doc-des">
              <Button
                variant="outlined"
                onClick={handleAddDocTrade}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload File from Document Vault
              </Button>
              <br />
              <Button
                variant="outlined"
                component="label"
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload file from Local Drive
                <input
                  type="file"
                  hidden
                  onChange={(e) => setTempTradeFile(e.target.files[0])}
                  accept="application/pdf"
                />
              </Button>
            </div>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleConfirmTrade}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
              disabled={!tempTradeFile}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Modal>
      {/* KYC Modal */}
      <Modal open={openKycModal} onClose={handleCloseKycModal}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="h6">
              Upload Company Profile / KYC Docs
            </Typography>
            <IconButton onClick={handleCloseKycModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          {/* Conditional rendering based on kycDocumentValut */}
          {kycDocumentValut ? (
            <>
              {/* Back Button */}
              <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleBackToKycUploadOptions}
                  sx={{
                    border: "1px solid #FF5722",
                    color: "#FF5722",
                    textTransform: "capitalize",
                  }}
                >
                  Back
                </Button>
              </Box>
              {/* First Autocomplete for documentCategoryMaster */}
              <FormControl sx={{ width: "100%", mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                >
                  Search Document Category
                </Typography>
                <Autocomplete
                  options={documentCategoryMaster}
                  getOptionLabel={(option) => option.Value || ""}
                  onChange={(event, newValue) => {
                    setSelectedKycVaultFile(newValue);
                    setTempKycFile(null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Type to search categories..."
                      variant="outlined"
                      sx={{
                        height: "40px !important",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ff9800",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#fb8c00",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff3e0",
                        },
                      }}
                    >
                      <Typography variant="body2">{option.Value}</Typography>
                    </Box>
                  )}
                  noOptionsText="No categories found"
                  sx={{ backgroundColor: "white" }}
                />
              </FormControl>
              {/* Second Autocomplete for documentVaultUserFiles when a category is selected */}
              {selectedKycVaultFile && (
                <FormControl sx={{ width: "100%", mb: 3 }}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                  >
                    Select Document
                  </Typography>
                  <Autocomplete
                    options={documentVaultUserFiles.filter(
                      (doc) => doc.Category === selectedKycVaultFile.Value
                    )}
                    getOptionLabel={(option) => option.DocumentName || ""}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setTempKycFile({
                          name: newValue.DocumentName,
                          DocumentFile: newValue.DocumentFile,
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Type to search documents..."
                        variant="outlined"
                        sx={{
                          height: "40px !important",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                            borderRadius: "4px",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#ff9800",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#fb8c00",
                            },
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          "&:hover": {
                            backgroundColor: "#fff3e0",
                          },
                        }}
                      >
                        <Typography variant="body2">
                          {option.DocumentName}
                        </Typography>
                      </Box>
                    )}
                    noOptionsText="No documents found"
                    sx={{ backgroundColor: "white" }}
                  />
                </FormControl>
              )}
              {/* Selected Files List */}
              <Box>
                {tempKycFile ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "5px",
                      borderRadius: "8px",
                      bgcolor: "#f5f5f5",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2">{tempKycFile.name}</Typography>
                    <IconButton
                      onClick={() => {
                        setTempKycFile(null);
                      }}
                    >
                      <CloseIcon sx={{ color: "#555" }} />
                    </IconButton>
                  </Box>
                ) : (
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    No file selected
                  </Typography>
                )}
              </Box>
            </>
          ) : tempKycFile ? (
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Typography variant="body2" sx={{ mr: 1 }}>
                {tempKycFile.name}
              </Typography>
              <IconButton onClick={() => setTempKycFile(null)}>
                <RemoveIcon
                  sx={{
                    backgroundColor: "#fb8c00",
                    color: "#fff",
                    borderRadius: "24px",
                    width: "35px",
                    height: "35px",
                  }}
                />
              </IconButton>
            </Box>
          ) : (
            <div className="doc-des">
              <Button
                variant="outlined"
                onClick={handleAddDocKyc}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload File from Document Vault
              </Button>
              <br />
              <Button
                variant="outlined"
                component="label"
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload file from Local Drive
                <input
                  type="file"
                  hidden
                  onChange={(e) => setTempKycFile(e.target.files[0])}
                  accept="application/pdf"
                />
              </Button>
            </div>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleConfirmKyc}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
              disabled={!tempKycFile}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Modal>
    </div>
  );
};
export default FinanceRfqsOffers;
